import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
            
            if(dataSlideAuto === '1') {
                let boutonPlayPause = document.getElementById('js-boutonAutoplay')

                boutonPlayPause.addEventListener('click', function () {

                    if(swiperHome.autoplay.running === true) {
                        swiperHome.autoplay.stop();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--play')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--pause');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }

                    else {
                        swiperHome.autoplay.start();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--pause')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--play');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }
                });
            }
        }
    }

    // Slider News

    const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;

    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, A11y ]);

        let postsConfig = {
            grabCursor : 'true',
            speed: 700,
            // loop : true,
            slidesPerView: 1,
            spaceBetween: 20,

            breakpoints: {
                800: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },

                961: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                1201: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
            },

            navigation: {
                prevEl: `.js-posts-swiper-nav--prev`,
                nextEl: `.js-posts-swiper-nav--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);             
    }
    
    // Slider Events
    const eventsSlideshow = document.querySelector('.events .swiper-container') !== null;

    if (eventsSlideshow) {
        let nbSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;
        let eventsNav = document.getElementById('js-eventsNav');

        Swiper.use([ A11y, Autoplay, Navigation ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : false,
            slidesPerView : 3,
            spaceBetween: 30,

            navigation: {
                enabled: true,
                nextEl: `.events__navigation .swiper-button-next`,
                prevEl: `.events__navigation .swiper-button-prev`,
            },

            breakpoints: {
                1201: {
                    slidesPerView : 3,
                    spaceBetween: 30,
                },
                961: {
                    slidesPerView : 3,
                    spaceBetween: 20,
                },
                641: {
                    slidesPerView : 2,
                    spaceBetween: 20,
                },
                0: {
                    slidesPerView : 1,
                    spaceBetween: 20
                }
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
            
            on: {
                breakpoint: function () {
                    if(window.innerWidth > 960 && nbSlides <= 2) {
                        console.log(eventsNav)
                        eventsNav.classList.add('js-eventsNav--no-slider');
                    }
                    
                    if(960 >= window.innerWidth > 640 && nbSlides <= 2){
                        eventsNav.classList.add('js-eventsNav--no-slider');
                    }
                    else if(960 >= window.innerWidth > 640 && nbSlides > 2){
                        eventsNav.classList.remove('js-eventsNav--no-slider');
                    }
                    
                    if(window.innerWidth <= 640 && nbSlides <= 1) {
                        eventsNav.classList.add('js-eventsNav--no-slider');
                    }
                }
            }
        }

        if(nbSlides > 1) {
            let swiperEvents = new Swiper('.events .swiper-container', config);
        }
    }

}
